export const emailStreamLabels = {
  3: "Marketing",
  4: "Offers",
  5: "News and Events",
  6: "Broadcast",
};

export const defaultEmailStreams = [
  {
    label: "Marketing",
    name: "marketing",
    variety: 3,
    translation_key: "mixer:email_stream_marketing_label",
    description_translation_key: "mixer:email_stream_marketing_description",
  },
  {
    label: "Offers",
    name: "offers",
    variety: 4,
    translation_key: "mixer:email_stream_offers_label",
    description_translation_key: "mixer:email_stream_offers_description",
  },
  {
    label: "New and Events",
    name: "news_and_events",
    variety: 5,
    translation_key: "mixer:email_stream_news_and_events_label",
    description_translation_key:
      "mixer:email_stream_news_and_events_description",
  },
].map((m) => ({
  ...m,
  label: emailStreamLabels[m.variety],
}));

export const frenchEmailStreamLabels = {
  3: "Marketing",
  4: "Offres",
  5: "Nouvelles et événements",
  6: "Broadcast",
};
